export class PathBuilder {
    constructor() {
        this.array = [];
    }
    moveTo(x, y) {
        this.array.push(`M ${x} ${y}`);
    }
    lineTo(x, y) {
        this.array.push(`L ${x} ${y}`);
    }
    closePath() {
        if (this.array.length > 0)
            this.array.push('Z');
    }
    toString() {
        return this.array.join(' ');
    }
}
